var render, staticRenderFns
import script from "./developer.vue?vue&type=script&lang=js"
export * from "./developer.vue?vue&type=script&lang=js"
import style0 from "./developer.vue?vue&type=style&index=0&id=1d3fdde4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3fdde4",
  null
  
)

export default component.exports